/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

import { Paragraph, Heading } from "../UI/Typoraphy";
import Rating from "../Rating";

import TripAdvisor from "../../assets/TripAdvisor.svg";
import { mq } from "../responsive";

const Card = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 3rem;

  border-radius: 2rem;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  position: relative;

  &:after {
    content: "";
    background-size: 90%;
    background-position: center center;
    background-repeat: no-repeat;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.05;
  }
`;

const Review = ({ review, styles, background = TripAdvisor }) => {
  const { avatar, name, rate, comment } = review;
  return (
    <Card
      css={{
        "&:after": {
          backgroundImage: `url(${TripAdvisor})`,
        },

        [mq.xl]: {
          maxWidth: "1440px",
          height: "528px",
          padding: "14rem 30rem",
          margin: "auto",
        },
      }}
    >
      <figure
        css={{
          width: "15rem",
          height: "15rem",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "50%",
          marginBottom: "1rem",
        }}
      >
        <img src={avatar} alt="customer avatar" css={{ width: "100%" }} />
      </figure>
      <Heading style={{ marginBottom: "1rem" }}>{name}</Heading>
      <Rating rate={rate} />
      <Paragraph
        style={{
          marginTop: "1rem",
          textAlign: "center",
          userSelect: "none",
          minHeight: "6rem",
        }}
      >
        {comment}
      </Paragraph>
    </Card>
  );
};

export default Review;
